import Joi from "joi";

const ReferenceDoctorName = Joi.object({
  referenceDoctorName: Joi.string().trim().required().messages({
    "string.empty": "Ref. Doctor Name is required.",
  }),
}).unknown(true);

export default ReferenceDoctorName;
